export const LOGISTICS_FIELDS = ["delivery_details", "pickup_details", "notes"] as const;

export type LogisticsField = typeof LOGISTICS_FIELDS[number];
export type LogisticsValues = Record<LogisticsField, string | null>;

export const LOGISTICS_LABELS: Record<LogisticsField, string> = {
  delivery_details: "Delivery details",
  pickup_details: "Pickup details",
  notes: "Event details"
};

export interface EventLogistics extends LogisticsValues {
  invoice_id: string;
  edit_version: number;
  updated_at: string | null;
  updated_by_email: string | null;
}

export interface LogisticsHistoryEntry {
  edit_version: number;
  previous: LogisticsValues;
  saved: LogisticsValues;
  changed_at: string;
  changed_by_email: string;
}

export interface LogisticsResponse {
  logistics: EventLogistics;
  history: LogisticsHistoryEntry[];
}
